export default "__VITE_ASSET__BOnDTvyc__"